// 管理端测试环境
// const GLOBAL_API_ROOT = 'http://xunzheng-test.i-tcm.cn/'; // 后端请求地址
const GLOBAL_API_ROOT = '/'; // 后端请求地址
const GLOBAL_SYSTEM = '';
const PROJECT_NAME = '民族医循证智能平台'; // 项目名称
const LOGO = '/common/xunzheng.png'; // 项目logo
const ICO = ''; // logo路径,格式为.ico，大小需要256*256的，否则打包会报错
const SYSTEM_NAV = {
    customerNav: [{
            name: '首页',
            value: '首页',
            activePath: '/home',
            path: '/home/folder',
        },
        {
            name: '科研专栏',
            value: '科研专栏',
            activePath: '/keyan',
            path: '/keyan/folder',
        },
        {
            name: '知识库',
            value: '知识库',
            activePath: '/main/knowledge',
            path: '/main/knowledge/literature-folder',
        },
        {
            name: '循证服务',
            value: '循证服务',
            activePath: '/xunzheng',
            path: '/xunzheng/folder',
        },
        {
            name: '循证资源',
            value: '循证资源',
            activePath: '/resources',
            path: '/resources',
        },
        {
            name: 'EDC工作台',
            value: 'EDC工作台',
            path: 'https://minzuyi.i-tcm.cn',
        },
    ],
    leftNav: [{
            name: '科研管理',
            value: '科研管理',
            activePath: '/main/manage',
            path: '/main/manage/list',
        },
        {
            name: '知识库管理',
            value: '知识库管理',
            activePath: '/main/knowledge',
            path: '/main/knowledge/literature',
        },
        {
            name: '循证管理',
            value: '循证管理',
            activePath: '/xunzheng',
            path: '/xunzheng/consult-manage',
        },
        {
            name: '评价管理',
            value: '评价管理',
            activePath: '/main/feedback',
            path: '/main/feedback/list',
        },
    ],
}




// 以下是打包桌面端需要用到的,暂时不用管
// electron-builder.yml
const APP_ID = 'com.xunzheng.www'; // 应用的唯一id,确认后不要改动了！不然在更新时候，会被认做为两个应用。这个是在apple那里你申请证书的时候，用生成的那个id就可以，类似这种'com.example.app'
const COPYRIGHT = 'xunzheng' // 版权信息

// package.json
const VERSION = '1.0.0'; //版本号
const PACKAGE_NAME = 'xunzheng'; //包名
module.exports = {
    GLOBAL_API_ROOT,
    GLOBAL_SYSTEM,
    PROJECT_NAME,
    LOGO,
    SYSTEM_NAV,
    ICO,
    APP_ID,
    COPYRIGHT,
    VERSION,
    PACKAGE_NAME,
};